<app-admin-navigation/>

<div class="container-fluid">
    <div class="row">
        <div class="col mt-3">

            {{ assignedCodes }} von {{ codes.length }} zugewiesen

            <div class="table-responsive">
                <table class="table table-sm table-hover mt-3">
                    <thead>
                    <tr>
                        <th>Nummer</th>
                        <th>Zugewiesen</th>
                        <th>Element</th>
                        <th>Interne Notiz</th>
                    </thead>
                    <tbody>
                    <tr *ngFor="let code of codes" (click)="selectCode(code)">
                        <td class="text-uppercase">
                            {{ slug }}-{{ code.number }}
                        </td>
                        <td>
                            <span class="text-muted" *ngIf="code.assigned == '0'">Nein</span>
                            @if (code.assigned == '1') {
                                @if (code.assignedType == 'folder') {
                                    Ordner
                                } @else if (code.assignedType == 'file') {
                                    Dokument
                                } @else if (code.assignedType == 'link') {
                                    Link
                                }
                            }
                        </td>
                        <td>
                            @if (code.assigned == '1') {
                                {{ code.assignedName }}
                            }
                        </td>
                        <td>
                            {{ code.note }}
                            <span class="text-muted" *ngIf="!code.note">Nicht gesetzt</span>
                        </td>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>

<div bsModal #codeModal="bs-modal" class="modal fade" tabindex="-1"
     role="dialog" aria-labelledby="dialog-sizes-name1">
    <div class="modal-dialog">
        <div class="modal-content" *ngIf="openedCode">
            <div class="modal-header">
                <h4 class="modal-title pull-left">QR Code <span class="text-uppercase">{{ slug }}-{{ openedCode.number }}</span></h4>
                <button type="button" class="btn-close close pull-right" aria-label="Close"
                        (click)="codeModal.hide()">
                    <span aria-hidden="true" class="visually-hidden">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div>
                    <label class="form-label">Interne Notiz</label>
                    <input type="text" class="form-control" name="note" [(ngModel)]="openedCode.note" placeholder="zB. Standort" required>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-success"
                        (click)="updateCode()">
                    Aktualisieren
                </button>
                <button type="button" class="btn btn-secondary float-end"
                        (click)="closeCode()">
                    Schließen
                </button>
            </div>
        </div>
    </div>
</div>
